'use client'
import LocaleLink from '@/components/LocaleLink';
import ScrollUp from '@/components/ScrollUp';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';

const Footer =  ({ locale }: { locale: string }) => {
	const t =  useTranslations('Footer');
	const pathName = usePathname()
	const links = [
		{ href: '/privacy-policy/', label: t('confidentialPolicy') },
		{ href: '/terminos-condiciones/', label: t('usagePolicy') },
		{ href: '/cookie-policy/', label: t('cookiePolicy') },
	];

	return (
		<footer className="bg-blue-light relative mt-10 py-6">
			<nav className="page-container tablet:gap-8 grid grid-cols-1 items-center gap-3 sm:grid-cols-[1fr_1fr] md:grid-cols-[2fr_auto_auto_auto]">
				<p className="text-dark">
					© {new Date(Date.now()).getFullYear()} Autoparts Wiki -
					<br />
					{t('autopartsSlogan')}
				</p>

				{links.map(({ href, label }) => (
					<LocaleLink
						key={href}
						href={href}
						locale={locale}
						isActive={pathName !== href}
						className="btn text-blue-deep p-0">
						{label}
					</LocaleLink>
				))}
			</nav>
			<ScrollUp className="bottom-13 sm:bottom-13 tablet:bottom-10 tablet:right-6 absolute right-0" />
		</footer>
	);
};
export default Footer;
